export const SET_CLAIMS = 'claims/set';
export const ADD_CLAIMS_TO_LIST = 'claims/add';
export const EDIT_CLAIMS_IN_LIST = 'claims/edit';
export const DELETE_CLAIMS_FROM_LIST = 'claims/delete';
export const CLEAR_CLAIMS = 'claims/clear';
